export default __webpack_public_path__ + "static/media/ovo.8b578c41.svg";